export const PERMISSIONS = {
    Admin: "caderno_conformidade.admin",
    Visitante: "caderno_conformidade.visitante",
    ReguladorRead: "caderno_conformidade.regulador.read",
    ReguladorWrite: "caderno_conformidade.regulador.write",
    RequisitanteRead: "caderno_conformidade.requisitante.read",
    RequisitanteWrite: "caderno_conformidade.requisitante.write",
}